export default __webpack_public_path__ + "static/media/gulp.282e4b02.png";